import { IS_PROD } from "lib/config";

/* eslint-disable no-console */
export function track(category, event) {
    if (window.ga) {
        window.ga("send", "event", {
            eventCategory: category,
            eventAction: event,
        });
    }

    if (window.fbq && category !== "ERROR") {
        window.fbq("track", "ViewContent", {
            content_name: event,
            content_category: category,
        });
    }

    if (!IS_PROD) {
        console.log("[track]", category, event);
    }
}

export function heapTrack(eventName, eventProps) {
    if (window.heap) {
        window.heap.track(eventName, eventProps);
    }

    if (!IS_PROD) {
        console.log("[HEAP]", eventName, eventProps);
    }
}
/* eslint-enable */
